export default "__VITE_ASSET__DkUZFLzu__"